export const getPagination = ({ pagination }) => pagination;
export const plano_empty = () => ({
  nome: "",
  descricao: null,
  visivel: true,
  valor: 0,
  valor_base: "0",
  max_usuarios: 10,
});
